import React, { useRef } from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import { Error as ErrorBoundary, MetaData } from "../../../../components";
import layoutHOC from "HOC/layoutHOC";
import config from "constants/config";
import Header from "./header";
import Sidebar from "./sidebar";
import onboardingSettingsHOC from "HOC/onboardingSettingsHOC";
import NotFound from "../../../../components/404-2";
import settingsRoute from "../../routes/settings";
import useMobile from "../../../../hooks/useMobile";
import { useSelector} from "react-redux";
import useWindowSize from "../../../../hooks/useWindowSize";

import "./index.scss";


const SettingsLayout = () => {

    const formRef = useRef();
    const isMobile = useMobile();
    const bannerHeight = useSelector(({nav}) => nav.bannerHeight);
    const { windowHeight } = useWindowSize();

    return (
        <GoogleReCaptchaProvider reCaptchaKey={config.CAPTCHA_SITE_KEY_V3}>
            <ErrorBoundary>
                <div className="app">
                    <Header formRef={formRef} />

                    <div className="app-body" style={{ height: `calc(${windowHeight}px - ${bannerHeight}px - 3.5rem - ${isMobile ? '3rem' : '1px'})` }}>

                        <main className="main ml-0">
                            <div className="container" style={{ maxWidth: 1280 }}>
                                <div className="settings-screen">

                                    <Sidebar formRef={formRef} />

                                    <div className="settings-content-wrapper">
                                        <Switch>
                                            {settingsRoute.map(({ path, pathTo, noindex, redirect, metadata, component: Component }, key) => (
                                                redirect ?
                                                    <Redirect from={path} to={pathTo} key={key}/> :
                                                    <Route path={path} key={key}>
                                                        <MetaData isDashboard meta={metadata} noindex={noindex}>
                                                            <Component formRef={formRef}/>
                                                        </MetaData>
                                                    </Route>
                                            ))}
                                            <Route path="*">
                                                <NotFound isDashboard />
                                            </Route>
                                        </Switch>
                                    </div>
                                </div>
                            </div>
                        </main>

                    </div>
                </div>
            </ErrorBoundary>
        </GoogleReCaptchaProvider>
    );
};

export default layoutHOC(onboardingSettingsHOC(SettingsLayout))
